<template>
  <element>
    <AppBar :title="title" />
    <v-container class="pt-0">
      <v-icon class="page-icon" color="#2e384d" size=60>mdi-car</v-icon>
      <p class="desc">{{ $t('enterCarDetails.description') }}</p>
      <form action="#" @submit.prevent="submit">
        <SearchTextField
          ref="SearchCarMakeInput"
          v-model="selectedCarMake"
          :label="$t('enterCarDetails.carMake')"
          placeholder="start typing a make..."
          type="search"
          apiEndpoint="makes"
          display_attribute="name"
          value_attribute="car_make_id"
          v-on:select="onCarMakeSelect"
          v-on:clear="onCarMakeClear"
          class="mt-3"
          required
        >
        </SearchTextField>
        <SearchTextField
          ref="SearchCarModelInput"
          :label="$t('enterCarDetails.carModel')"
          placeholder="start typing a model..."
          type="search"
          apiEndpoint="models"
          display_attribute="model_year"
          value_attribute="car_model_id"
          :options="selectedCarMakeId"
          v-on:select="onCarModelSelect"
          v-on:clear="onCarModelClear"
          class="mt-3"
          required
        >
        </SearchTextField>
        <LabelSelectField
          ref="modelYear"
          class="mt-3"
          :items="carModelYearItems"
          :label="$t('enterCarDetails.modelYear')"
          :modelYear="selectedValue"
          required
        ></LabelSelectField>
        <LabelTextField 
          ref="purchasePrice"
          placeholder="123.456,78"
          type="number"
          class="mt-3" 
          :label="$t('enterCarDetails.purchasePrice')"
          required
          unit="kr" 
        ></LabelTextField>
        <LabelTextField
          ref="mileage"
          placeholder="234.567,89"
          type="number"
          class="mt-3"
          :label="$t('enterCarDetails.mileage')"
          required
          unit="km"
        ></LabelTextField>
        <LabelTextField
          ref="licensePlateNumber"
          class="mt-3"
          :label="$t('enterCarDetails.registrationNumber')"
        ></LabelTextField>
        <LabelTextArea
          ref="notes"
          class="mt-3"
          :label="$t('enterCarDetails.notes')" 
        ></LabelTextArea>
        <v-btn
          class="submit-btn"
          type="submit"
          height="45px"
          color="#033e8c"
          depressed
          block
          dark
          >
          {{ title }}
        </v-btn>
      </form>
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue"
import LabelSelectField from "@/components/common/LabelSelectField.vue"
import LabelTextField from "@/components/common/LabelTextField.vue"
import LabelTextArea from "@/components/common/LabelTextArea.vue"
import SearchTextField from "@/components/search/SearchTextField.vue"

export default {
  name: "EnterCarDetailsPage",
  props: {},
  components: {
    AppBar,
    LabelSelectField,
    LabelTextField,
    LabelTextArea,
    SearchTextField
  },
  data() {
    return {
      title: '',
      valid: false,
      licensePlateNumber: '',
      purchasePrice: '',
      mileage: '',
      notes: '',
      carModelYearItems:[],
      selectedCarMake: null,
      selectedCarMakeId: '',
      selectedCarModelId:'',
      modelYear:null,
    }
  },
  methods: {
    submit() {
      const variables = {
        "variables": {
          "car_make_id":{
            "value":this.selectedCarMakeId,
            "type":"Integer"
          },
          "car_model_id":{
            "value":this.selectedCarModelId,
            "type":"Integer"
          },
          "model_year":{
            "value":this.$refs.modelYear.selectedValue,
            "type":"Integer"
            // td 202201310935 known bug: if we type the value instead of selecting it in the list it won't get captured here as "selectedValue" and will be empty in the process instance
          },
          "purchase_price": {
            "value":this.$refs.purchasePrice.textValue,
            "type":"Double"
          },
          "mileage": {
            "value":this.$refs.mileage.textValue,
            "type":"Integer"
          },
          "license_plate_number": {
            "value":this.$refs.licensePlateNumber.textValue.trim().toUpperCase(),
            "type":"String"
            // todo: replace superfluous caracters like space and dash using regexp
          },
          "notes": {
            "value":this.$refs.notes.textValue,
            "type":"String"
          }
        }
      }

      const taskId = this.$store.getters.getCurrentTask?.id

      if (taskId) {
        this.$store.dispatch('completeTask', { taskId, variables })
        .then(response => {
          console.log("Task completed successfully!", taskId, response)
        })
        .catch(error => {
          console.log("Failed completing task!", taskId, error)
        })
      }
    },
    initialData(){
       let currentYear = new Date().getFullYear();
        for (let i = currentYear; i >= 1980; i--) {
          this.carModelYearItems.push(i);
        }
    },
    onCarMakeSelect(carMakeData) {
      this.selectedCarMakeId = carMakeData.car_make_id;
    },
    onCarMakeClear(){
      this.selectedCarMakeId = '';
    },
    onCarModelSelect(carMakeData){
      this.selectedCarModelId = carMakeData.car_model_id;
    },
    onCarModelClear(){
      this.selectedCarModelId='';
    }
  },
  created() {
    this.initialData();
    this.title = this.$store.getters.getCurrentTask.taskName
    const pid = this.$store.getters.getCurrentPID
    this.$store.dispatch('retrieveProcessVariables', pid)
    .then(response => {
      try {
        this.$refs.carMake.selectedValue = response.data.data.car_make_id.value
        this.$refs.carModel.selectedValue = response.data.data.car_model_id.value
        this.$refs.modelYear.selectedValue = response.data.data.model_year.value
        this.$refs.licensePlateNumber.textValue = response.data.data.license_plate_number.value
        this.$refs.purchasePrice.textValue = response.data.data.purchase_price.value
        this.$refs.mileage.textValue = response.data.data.mileage.value
        this.$refs.notes.textValue = response.data.data.notes.value
      } catch (error) {
        console.log("Failed retrieving variables from API.", error)
      }
    })
    .catch(error => {
      console.log("Failed retrieving variables from API", error)
    })
  }
}
</script>

<style scoped>
</style>